import { commentDiscussionIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Conversation = createIcon({
  displayName: 'Conversation',
  paths: [
    'M170.667 512v-341.333h512v341.333h-512zM682.667 85.333h-512c-47.104 0-85.333 38.229-85.333 85.333v341.333c0 47.104 38.229 85.333 85.333 85.333h42.667v170.667l204.8-170.667h264.533c47.104 0 85.333-38.229 85.333-85.333v-341.333c0-47.104-38.229-85.333-85.333-85.333zM933.188 311.189c-16-42.325-79.872-28.971-79.872 16.213v355.285h-388.821c-9.984 0-19.669 3.499-27.307 9.856-30.677 25.557-12.629 75.477 27.307 75.477h141.397l204.757 170.667v-170.667h42.667c47.147 0 85.333-38.229 85.333-85.333v-341.333c0-10.624-1.92-20.779-5.461-30.165zM298.667 384h256c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-256c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z'
  ],
  canvasPaths: canvasIconPaths(commentDiscussionIcon)
})
